import { Component, Input } from '@angular/core';

/**
 * @fileOverview
 * Media library component
 * Manage templates/games medias (pictures/videos)
 * Medias are stored at template/game level
 * Medias used in game missions can be selected from media lib to avoid file doublons
 *
 * @author Stephane Draux <stephane.draux@gmail.com>
 */

@Component({
    selector: 'app-resource-selector',
    templateUrl: './resource-selector.component.html',
    styleUrls: ['./resource-selector.component.scss'],
    standalone: false
})

export class ResourceSelectorComponent {

  @Input() resources;
  @Input() resourceQuantities;

  constructor() {
  }

  ngOnInit() {
  }
}